import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material"
import { formatarValorMonetario } from "../../../../../../../../helpers/masks"
import { TDetalhesTotalFechamento } from "../../../../../../../../types/api/financeiro/detalhar-fechamentos-conta-corrente"
export default function DialogDetalheTotal({
    open,
    label,
    total,
    handleClose
}: DialogDetalheTotalProps) {

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth='xs'
            fullWidth
        >
            <DialogTitle>Detalhe dos {label}</DialogTitle>
            <DialogContent>
                <TableContainer sx={{ border: '1px solid #ccc' }}>
                    <Table size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell sx={{fontWeight: 'bold'}}>Ref. leite</TableCell>
                                <TableCell align="right">{label === 'créditos' ? formatarValorMonetario(total.creditos_leite) : formatarValorMonetario(total.debitos_leite)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{fontWeight: 'bold'}}>Outros {label}</TableCell>
                                <TableCell align="right">{label === 'créditos' ? formatarValorMonetario(total.creditos_sem_leite) : formatarValorMonetario(total.debitos_sem_leite)}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={handleClose}
                    size="small"
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogDetalheTotalProps {
    open: boolean,
    handleClose: VoidFunction
    label: "débitos" | "créditos"
    total: TDetalhesTotalFechamento
}